export const truncateText = (text, maxCharacters) => {
  if (!text || text.length <= maxCharacters) return text;
  return `${text.slice(0, maxCharacters)}…`;
};
